import { computed, toValue } from "vue";
import { useComponentGraphStoreV2 } from "..";
export const useComponentVariableImmediateParentComponentId = (componentId, variableName) => {
    const componentGraphStore = useComponentGraphStoreV2();
    const componentVariableImmediateParentComponentId = computed(() => {
        var _a;
        const componentIdValue = toValue(componentId);
        const variableNameValue = toValue(variableName);
        if (!componentIdValue || !variableNameValue) {
            return undefined;
        }
        return (_a = componentGraphStore.getComponentVariableNodeContext(componentIdValue, variableNameValue)) === null || _a === void 0 ? void 0 : _a.immediateParentComponentId;
    });
    return {
        componentVariableImmediateParentComponentId,
    };
};
